import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import dirt5Logo from "assets/images/logos/logo_dirt5.png";
import routes from "routes";
import getAnchorRoute from "utils/getAnchorRoute";
import RouterAnchorLink from "components/links/RouterAnchorLink";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: { "&:hover": { "& img": { opacity: 0.9 } } },
    });
});

interface IProps extends HTMLAttributes<HTMLImageElement> {
    size?: number;
}

export default function HomeLogo(props: IProps) {
    const { size, ...rest } = props;
    const classes = useStyles();

    return (
        <RouterAnchorLink
            className={classes.root}
            to={getAnchorRoute(routes.home.route, routes.home.anchors.root)}
        >
            <img
                src={dirt5Logo}
                alt="Dirt 5 Logo"
                style={{ width: typeof size === "undefined" ? "100%" : size }}
                {...rest}
            />
        </RouterAnchorLink>
    );
}
